import React, { useState, useEffect } from 'react';
//import { useAuth0 } from '@auth0/auth0-react';

import { IoMdCloseCircle } from "react-icons/io";
import { useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getURLBasePath } from '../../tools/utils';
import toast from 'react-hot-toast';

const Register = () => {
  const { setUsuario } = useContext(AuthContext);
  const navigate = useNavigate();

  // const { loginWithRedirect } = useAuth0();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [celular, setCelular] = useState('');
  
  const [apellido, setApellido] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false)
  const [tiposDeDocumento, setTiposDeDocumento] = useState([{
    id: 1
  }])
  const [tipoDocumentoSeleccionado, setTipoDocumentoSeleccionado] = useState('')
  const [numeroDocumento, setNumeroDocumento] = useState('')

  useEffect(() => {
    const data = { peticion: 8 };
    const url = `${getURLBasePath()}/serviciosEmpleados.php`;

    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: new Headers(),
    })
      .then((res) => res.json())
      .then((resultado) => {
        if (resultado) {
          //console.log(resultado)
          setTiposDeDocumento(resultado);
          setTipoDocumentoSeleccionado(resultado[0]?.id); // valor inicial
        }
      })
      .catch((error) => console.error("Error:", error));
  }, []);




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password || !name || !apellido || !numeroDocumento || !tipoDocumentoSeleccionado) {
      setErrorMsg('Por favor completá los campos');
      return;
    }

    if (password !== confirmPassword) {
      setErrorMsg('Las contraseñas no coinciden');
      return;
    }

    try {
      const data = {
        peticion: 14,
        param: {
          proveedor: 'mail',
          id_proveedor: email,
          correo: email,
          nombre_completo: `${name} ${apellido}`,
          foto_perfil: null,
          token_acceso: password,
          token_refresh: password,
          expira_en: null,
          scopes: null,
          esLogin: 0,
          entidadG: {
            numeroDocumento: numeroDocumento,
            idTipoDocumento: tipoDocumentoSeleccionado,
            email: email,
            celular: celular
            
          },
          
        }
      }
      //return console.log(data);

      setLoading(true)
      const response = await fetch('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosUsuario.php', {
        method: 'POST',
        headers: new Headers(), // no incluimos Content-Type para evitar preflight
        body: JSON.stringify(data),
      })
      const result = await response.json();

      if (result) {
        setUsuario(result.data)
        localStorage.setItem('usuario', JSON.stringify(result.data));
        toast.success(`Hola 👋 ${result.data.nombre_completo}✨`, {
          duration: 4000,
          position: "top-center",
        });
        navigate('/reserva'); // o donde quieras redirigirlo
      }
    }
    catch (error) {
      console.error('Error en la Request', error)

    }
    finally {
      setLoading(false)
    }
  };

  


  return (
    <>

      <div className='min-h-screen py-40 px-5 flex justify-center '>
        <div className="bg-white p-8 rounded-xl sm:max-w-lg md:m-0 w-full md:max-w-xl shadow-xl border border-gray-200">
          <form className="w-full" onSubmit={handleSubmit}>

            <h2 className="text-xl font-bebas mb-4">Crear usuario:</h2>
            <div className="mb-4 text-left">
              <label> Nombre:</label>
              <input name="name" type="text" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Nombre" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="mb-4 text-left">
              <label> Apellido:</label>
              <input name="apellido" type="text" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Apellido" value={apellido} onChange={(e) => setApellido(e.target.value)} />
            </div>


            <div className="flex flex-col min-w-0">
              <label className="text-sm text-gray-700 mb-1">Tipo de documento</label>

              <select
                name="idTipoDocumento"
                value={tipoDocumentoSeleccionado}
                onChange={(e) => setTipoDocumentoSeleccionado(e.target.value)}
                className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
                style={{ height: "60px" }}
              >
                {tiposDeDocumento?.map((tipo) => (
                  <option key={tipo.id} value={tipo.id}>
                    {tipo.descripcion}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4 text-left">
              <label>Numero Documento</label>
              <input name="documento" type="text" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Numero de Documento" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
            </div>


            <div className="mb-4 text-left">
              <label>Mail</label>
              <input name="email" type="email" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Mail" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="mb-4 text-left">
              <label>Celular</label>
              <input name="celular" type="text" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Celular" value={celular} onChange={(e) => setCelular(e.target.value)} />
            </div>
            <div className="mb-4 text-left">
              <label className="">Contraseña</label>
              <input name="password" type="password" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div className="mb-4 text-left">
              <label className="">Repetir Contraseña</label>
              <input name="password" type="password" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                placeholder="Confirmar contraseña" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            </div>
            {errorMsg && <p className="text-red-500 text-sm mb-4">{errorMsg}</p>}
            <button type="submit"
              className="mt-5 w-full rounded-lg bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 p-3 text-sm font-medium text-white transition"
              disabled={loading}>
              Continuar
            </button>

          </form>

        </div>
      </div>


    </>
  );
};

export default Register;